import React from 'react';

const SvgComponent = (props) => (
  <svg
    data-name="add circle active-layer"
    viewBox="0 0 18.02 18"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M3.62 0h-1.6l1.9 2H.01v1.1h3.8L2.02 5h1.6l2.5-2.5L3.62 0zM16.69 8.53l-2.86-1V4.08a2.07 2.07 0 0 0-2-2.18h-.12a2.06 2.06 0 0 0-1.56.72A2.07 2.07 0 0 0 6.55 4v6.12l-.43-.43a2.08 2.08 0 0 0-2.94 2.94l4.23 4.19A4.15 4.15 0 0 0 10.36 18h4.51A3.12 3.12 0 0 0 18 14.91v-4.45a2.08 2.08 0 0 0-1.31-1.93zm0 6.35a1.87 1.87 0 0 1-1.87 1.87h-4.46a2.89 2.89 0 0 1-2.06-.85l-4.23-4.23a.83.83 0 0 1 1.18-1.17l.43.43 2.13 2.13v-9a.9.9 0 0 1 .65-.91h.18a.82.82 0 0 1 .62.29l.32.36v4.46h1.24V3.8l.32-.36a.82.82 0 0 1 .62-.29h.18a.9.9 0 0 1 .65.91v4.4l.85.28 2.81.94a.83.83 0 0 1 .49.76z" />
  </svg>
);

export default SvgComponent;
